<template>
  <div id="app" loaded>
    <Checkout v-if="ready" :json="json"/>
  </div>
</template>

<script>
import Checkout from './components/Checkout.vue'
export default {
  components: {
    Checkout
  },
  data () {
    return {
      ready: false,
      json: {
        credentials: {
          sandbox: '<sandbox client id>',
          production: '<production client id>'
        },
        amount: 7,
        currency: 'NOK',
        env: 'sandbox',
        items: [
          {
            name: 'no name',
            description: 'no description',
            quantity: 1,
            price: 7,
            currency: 'NOK'
          }
        ],
        sendgrid_credentials: '',
        from_email: '',
        to_email: '',
        custom_text: '',
        custom_text_inquiry: '',
        prefix: 'kr ',
        suffix: ' NOK',
        seller_name: '',
        seller_address: '',
        seller_zip: '',
        seller_city: '',
        seller_phone: '',
        seller_country: '',
        email_ajax_url: ''
      }
    }
  },
  mounted () {
    Object.assign(this.json ,JSON.parse(
      decodeURIComponent(this.$el.parentElement.getAttribute('data-json')).replace(/___sp___/g, ' ')
    ))
    this.ready = true
  }
}
</script>

<style>
</style>
